var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"cld-video-player cld-video-player-skin-dark",attrs:{"id":'example-player' + _vm.myId,"controls":"","autoplay":_vm.shouldPlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }